$(document).ready(function () {
    // Function to initialize or refresh slick slider
    function initOrRefreshSlider($slider) {
        $slider.slick('refresh');
        $slider.slick('slickGoTo', 0);
    }

    // Intersection Observer setup
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // If slider is in view, initialize or refresh it
                initOrRefreshSlider($(entry.target));
                observer.unobserve(entry.target);
            }
        });
    });

    // Observe all sliders
    $('.project__gallery, .variable__width__gallery').each(function() {
        observer.observe(this);
    });

    /* used on: single-project or template-service */
    $('.project__gallery').slick({
        slide: '.project-gallery__item',
        rows: 0,
        // autoplay: true,
        // autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        fade: false,
        infinite: true,
        draggable: true,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: '150px',
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    centerPadding: '250px',
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    centerPadding: '450px',
                }
            }
        ]
    });

    $('.variable__width__gallery').slick({
        slide: '.project-gallery__item',
        rows: 0,
        //autoplay: true,
        //autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        fade: false,
        infinite: true,
        draggable: true,
        arrows: false,
        dots: true,
        centerMode: true,
        variableWidth: true,
        centerPadding: '60px',
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: '150px',
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    centerPadding: '250px',
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    centerPadding: '450px',
                }
            }
        ]
    });

    // Set initial position of sliders
    $('.project__gallery, .variable__width__gallery').slick('slickGoTo', 0);
});

$(window).on('load', function() {
    setTimeout(function() {
        // Set position of sliders after everything is loaded
        $('.project__gallery, .variable__width__gallery').slick('setPosition');
    }, 100); // Delay in milliseconds
});

